/** @module Sourcing/SupplierRequestCopyBreadcrumbController */
define([
	"dojo/_base/declare",
	"csi/breadcrumb/CopyController",
	"./CopySupplierRequestMixin"
], function(declare,Copy,CopySupplierRequestMixin) {
	
	return declare([Copy, CopySupplierRequestMixin], {
	});
});
